import { api, apiV1, apiV1BlobResponse } from '@/api';

export function pagination(link) {
    return api.get(link);
}

export function uploadImage(data, config) {
    return apiV1.post('/upload', data, config);
}

export function downloadFileBase64(params) {
    return apiV1.get('/home/upload/base64', { params });
}
export function deleteFile(id) {
    if (id) {
        return apiV1.delete(`upload/${id}`);
    }
}
export function downloadFile(url, onDownloadProgress) {
    return apiV1BlobResponse.get('/home/download', { onDownloadProgress: onDownloadProgress, params: { file: url } });
}

export function fetchRegions() {
    return apiV1.get('/home/regions');
}

export function fetchRegionsDistrict(id) {
    return apiV1.get(`/home/regions/${id}`);
}
